import React, { useContext, useEffect, useState } from 'react'

import Link from '@atoms/Link'
import Button from '@atoms/Button'
import Loading from '@atoms/Loading'
import Logo from '@atoms/Logo'
import LanguageSwitch from '@molecules/LanguageSwitch'
import Popup from '@molecules/Popup'
import SaveIcon from '@icons/Save'
import HistoryIcon from '@icons/History'
import MenuIcon from '@icons/Menu'
import CloseIcon from '@icons/Close'
import AuthIcon from '@icons/Auth'
import { StoreContext } from '@models/Store'
import { useScroll } from '@models/Util'
import { getLocalData, setLocalData } from '@models/LocalData'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

const Header = () => {
  const { ui, entity, action } = useContext(StoreContext)
  const { banner, showMenu } = ui
  const { setShowMenu } = action
  const { t, path } = useTranslation()
  const headerColor =
    showMenu || ['/', '/about'].includes(path) ? 'subWhite' : 'white'

  const { isTop, isScrollingDown } = useScroll()
  const closeMenu = () => setTimeout(() => setShowMenu(false), 100)

  const popupKey = 'header_popup'
  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowPopup(getLocalData(popupKey) !== 'remove'), 1000)
  }, [])

  const removePopup = () => {
    setShowPopup(false)
    setLocalData(popupKey, 'remove')
  }

  return (
    <div
      className={style.headerContainer}
      data-show-banner={banner !== undefined}
    >
      <header
        className={style.header}
        data-color={headerColor}
        data-small={!isTop && !showMenu}
        data-background={!showMenu}
        data-scrolling-down={!isTop && !showMenu && isScrollingDown}
      >
        <button
          className={style.menuSwitch}
          data-active={showMenu}
          onClick={() => setShowMenu(!showMenu)}
        >
          <MenuIcon />
          <CloseIcon />
        </button>
        <div className={style.logoContainer}>
          <Link to="/" onClick={closeMenu}>
            <Logo withText />
          </Link>
        </div>

        <Link to="/save" onClick={closeMenu} className={style.save}>
          <SaveIcon />
          {t('mypage.save')}
        </Link>
        <Link to="/history" onClick={closeMenu} className={style.history}>
          <HistoryIcon />
          {t('mypage.history')}
        </Link>
        <div className={style.languageContainer}>
          <LanguageSwitch design="white" />
        </div>
        <div
          className={style.authContainer}
          data-loading={entity.user === undefined}
        >
          {entity.user?.isSignIn ? (
            <Link to="/save">
              <Button design="white">{t('mypage.mypage')}</Button>
              <AuthIcon isSignIn={true} />
            </Link>
          ) : (
            <Link to="/signup">
              <Button design="white" loading={entity.user === undefined}>
                {t('mypage.registration')} / {t('mypage.login')}
              </Button>
              {entity.user === undefined ? (
                <div className={style.loadingContainer}>
                  <Loading design="white" size="small" />
                </div>
              ) : (
                <AuthIcon isSignIn={false} />
              )}
            </Link>
          )}
        </div>
        <div
          className={style.popupContainer}
          data-show={
            isTop &&
            entity.user !== undefined &&
            !entity.user.isSignIn &&
            showPopup
          }
        >
          <Popup onClose={removePopup}>
            <div className={style.contents}>
              <div className={style.label}>
                <span>NEW</span> {t('mypage.feature')}
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: t('mypage.featureText') }}
              />
              <Link to="/signup">
                <Button onClick={removePopup}>
                  {t('mypage.registration')} / {t('mypage.login')}
                </Button>
              </Link>
            </div>
          </Popup>
        </div>
      </header>
    </div>
  )
}

export default Header
